import React from 'react';
import { Paper } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import PropTypes from 'prop-types';
import { StyledTableCell, StyledTableRow } from './styledComponent';

export default function EnvContraintesTable({ rows }) {
  return (
    <TableContainer component={Paper} elevation={2} sx={{ mt: 2 }}>
      <Table aria-label="constraints-table" size="small">
        <TableHead>
          <TableRow>
            <StyledTableCell align="left">Enjeux environnementaux</StyledTableCell>
            <StyledTableCell align="left">Surface de la propriété impactée (%)</StyledTableCell>
            <StyledTableCell align="left">Libellé de la zone</StyledTableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, idx) => (
            <StyledTableRow key={idx}>
              <StyledTableCell align="left">{row.featureType}</StyledTableCell>
              <StyledTableCell align="left">{row.pourcentageSurfaceImpactee}</StyledTableCell>
              <StyledTableCell align="left">{row.label}</StyledTableCell>
            </StyledTableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

EnvContraintesTable.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      featureType: PropTypes.string.isRequired,
      pourcentageSurfaceImpactee: PropTypes.number.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
};
